import { Modal } from "./Modal";
import { Hatch, HatchMap, SafeString } from "../classes/Hatch";
import launch from "@icons/launch.svg";
import { Signature } from "../report_modules/interfaces";
import Utils from "../classes/Utils";

export class MitreModal {
  constructor(ttp) {
    let sigs = globalThis.page_data.task_report?.signatures || globalThis.page_data.overview?.signatures;

    ttp = globalThis.ttp_lookup[ttp];
    sigs = sigs.filter((sig: Signature) => sig.ttp?.includes(ttp.id));

    let body = Hatch`
    <div class="article">
        <h2>${ttp.name}</h2>
        <ul class="risk-rules">
            ${HatchMap(sigs, (sig: Signature) => {
              return Hatch`
                <li class="${Utils.getSeverity(sig.score)}">
                    <div class="title">
                        <b>
                            ${sig.name} <span>  ${sig.ttp?.length ? `${sig.ttp?.length} TTPs` : ""}
                            ${sig.indicators?.length ? `${sig.indicators?.length} Indicators` : ""}</span>
                        </b>
                        ${sig.desc ? Hatch`<p>${sig.desc}</p>` : ""}
                    </div>
                </li>
              `;
            })}
        </ul>
        <div class="button-bar">
            <a class="button small primary icon" href="${
              ttp.reference
            }" target="_blank">View on Mitre Att&ck${new SafeString(launch)}</a>
        </div>
    </div>
    `;
    new Modal({
      body: body,
    });
  }
}
